"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const objectWithoutPropertiesLoose_1 = __importDefault(require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"));
var _excluded = ["children"];
const React = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const styled_components_1 = __importDefault(require("styled-components"));
var ButtonLink = function ButtonLink(_ref) { var children = _ref.children, restProps = objectWithoutPropertiesLoose_1.default(_ref, _excluded); return /*#__PURE__*/ React.createElement(StyledButton, Object.assign({ variant: "outline-light" }, restProps), children); };
var StyledButton = styled_components_1.default(react_bootstrap_1.Button).withConfig({ displayName: "ButtonLink__StyledButton", componentId: "sc-t7xnap-0" })(["min-width:170px;"]);
exports.default = ButtonLink;
